export const AI_REVIEW_JOB_TYPE = {
  relevancy: 'RELEVANCY',
  issueCoding: 'ISSUECODE',
};

export const AI_REVIEW_EVALUATION_TYPE = {
  relevancy: 'relevancy',
  issueCode: 'issue-code',
} as const;

/** Create/update job API status (AVR-22264). Distinct from job-list UI status enum. */
export const AI_REVIEW_JOB_STATUS = {
  draft: 'Draft',
  submitted: 'Submitted',
} as const;

export const SPECIAL_CHARACTERS_NOT_ALLOWED = {
  characters: /[<>*;'/()#&]/,
};

export const NAME_REGEX = /^[a-zA-Z0-9 _-]*$/;

export const PROTOCOL_INTELLIGENCE_FIELDS = {
  issueCodes: 'ISSUE_CODES',
  relevanceCriteria: 'RELEVANCE_CRITERIA',
  caseContext: 'CASE_CONTEXT',
};

export const MAX_HEIGHT = 560;
export const MIN_HEIGHT = 268;
